module.exports = __webpack_public_path__ + "static/media/get_simple.ee73caef.gif";